/** @format */
import {
    Icon,
    IconSize,
    IconVariant,
} from '@mpb-com/feather/components/atoms/icon';
import { useTranslation } from 'next-i18next';
import React from 'react';
import styled from 'styled-components';

import TickIcon from '@toucan/client/global/icons/checkmark.svg';

import { TEST_ID as dataTestId } from './constants';
import { styles } from './same-accessories-notice.styles';

const StyledSameAccessoriesNotice = styled('div')`
    ${styles}
`;

export const SameAccessoriesNotice = () => {
    const { t } = useTranslation();
    return (
        <StyledSameAccessoriesNotice data-testid={dataTestId}>
            <div className="same-accessories__title">
                <Icon
                    variant={IconVariant.CORE}
                    size={IconSize.XL}
                    className="same-accessories__condition-icon"
                >
                    <TickIcon />
                </Icon>
                <p className="same-accessories__label">{t('Accessories')}</p>
            </div>
            <p className="same-accessories__description">
                {t('All these products come with the same accessories.')}
            </p>
        </StyledSameAccessoriesNotice>
    );
};
